import { isMobile as isMobileDevice } from 'react-device-detect';

// "Desktop site" mode rewrites the user agent, but these touch signals survive it.
const isTouchDevice = (): boolean =>
  navigator.maxTouchPoints > 1 && 'ontouchstart' in window;

export const useIsMobileOrTouchDevice = (): boolean =>
  isMobileDevice || isTouchDevice();
